import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router5';
import { AppContainer } from 'react-hot-loader';
import { I18nextProvider } from 'react-i18next';

import app from './app';
import store from './store';
import router from './router';
import i18nConfig from './i18n';

const render = (Component) => {
  const i18n = i18nConfig();

  router.setDependency('store', store);
  router.start( () => {
    ReactDOM.render(
      <AppContainer>
        <Provider store={ store }>
          <RouterProvider router={ router }>
            <I18nextProvider i18n={ i18n }>
              <Component />
            </I18nextProvider>
          </RouterProvider>
        </Provider>
      </AppContainer>,
      document.getElementById('root')
    );
  });
};

render(app);

if (module.hot) {
  module.hot.accept('./app', () => {
    render(app);
  });
}



// WEBPACK FOOTER //
// ./src/index.js